import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-empty-placeholder.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import '@ils/osces/client/ils-osce-type.js';
import { hasPermission } from '@ils/permissions/hasPermission.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';
import { filter, switchMap } from 'rxjs';
import { ExamDay } from '../../db/examdays.js';
import type { ILSUser } from '../../db/ils-user.js';
import '../components/ils-timeline-admin.js';
import '../components/ils-timeline.js';

const examDayselector = {
  _class: 1,
  _id: 1,
  candidateIDs: 1,
  osceTesterTuples: {
    _class: 1,
    testerIDs: 1,
    osceID: 1,
    osce: {
      _id: 1,
      taskType: 1,
      durationInMinutes: 1,
    },
  },
  fallbackTesters: 1,
} as const;

@customElement('ils-scheduling')
export class ILSScheduling extends ChemistryLitElement {
  override styles() {
    return [
      {
        ':host': {
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          minWidth: '0',
        },
      },
    ];
  }
  @state() public currentUser = new RXController(this, currentUser<ILSUser>());
  @state() public selectedDay = new RXController(
    this,
    routingState.searchParams.get('day').pipe(
      filter(Boolean),
      switchMap(examDayID => ExamDay.subscribeByID<ExamDay>(examDayID)(examDayselector)),
    ),
  );

  override render() {
    if (!this.currentUser.value) return nothing;
    const currentUser = this.currentUser.value;
    if (!this.selectedDay.value)
      return html`
        <x-empty-placeholder
          no-wrapper
          .text=${'Sie müssen zuerst eine Prüfung auswählen.'}
          .img=${'alarm'}
        ></x-empty-placeholder>
      `;
    if (!hasPermission(currentUser, 'timeline', 'view', this.selectedDay.value))
      return html`
        <x-empty-placeholder
          no-wrapper
          .text=${'Sie haben keinen Zugriff auf diese Prüfung.'}
          .img=${'close'}
        ></x-empty-placeholder>
      `;

    return html`
      <x-flex space="lg" ${css({ height: '100%' })}>
        <x-flex vertical space="md" flex ${css({})}> ${this.content()} </x-flex>
      </x-flex>
    `;
  }

  private content() {
    if (!this.currentUser.value || !this.selectedDay.value) return nothing;
    const currentUser = this.currentUser.value;
    if (hasPermission(currentUser, 'timeline', 'viewadmin'))
      return html` <ils-timeline-admin flex></ils-timeline-admin> `;
    return html` <ils-timeline flex></ils-timeline> `;
  }
}
